import type { FC } from 'react'
import { useEffect, useMemo, useState } from 'react'

import NavigationCategory from '../NavigationCategory'

interface CarrouselPlpProps {
  sectionTitle?: string
  cmsPlpData?: any
  slug?: string
}

const CarrouselPlp: FC<CarrouselPlpProps> = ({ cmsPlpData = {}, slug }) => {
  const [bannersCategories, setBannersCategories] = useState([])
  const [sectionTitle, setSectionTitle] = useState('')
  const {
    allCmsPlp: { edges },
  } = cmsPlpData

  useEffect(() => {
    edges.map(({ node: { sections } }: any) => {
      const section = sections.find((item: any) => {
        return item?.name === 'NavigationCategory' &&
          item?.data?.slug?.toLowerCase() === slug
          ? item
          : null
      })

      if (section) {
        setBannersCategories(section?.data?.banners)
        setSectionTitle(section?.data?.title)
      }

      return sections
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cmsPlpData])

  return useMemo(() => {
    return bannersCategories.length > 0 ? (
      <>
        {sectionTitle !== '' && <h5>{sectionTitle}</h5>}
        <NavigationCategory
          className="subcategory__list-plp"
          useFindCategories={false}
          useSeeAll
          title=""
          link=""
          banners={bannersCategories}
        />
      </>
    ) : null
  }, [bannersCategories, sectionTitle])
}

export default CarrouselPlp
